import { useEffect, useState } from "react";

/**
 * Reactief volgen van de OS-instelling "prefers-reduced-motion".
 *
 * Retourneert `true` zodra de gebruiker 'beperk animaties' heeft aanstaan
 * (macOS: System Settings → Accessibility → Display → Reduce motion;
 * iOS: Settings → Accessibility → Motion; Windows: Settings → Accessibility
 * → Visual effects → Animation effects).
 *
 * - SSR-veilig: start als `false` zonder window.
 * - Reageert live op wijzigingen via `addEventListener("change")`.
 */
export const useReducedMotion = (): boolean => {
  const [reduced, setReduced] = useState<boolean>(() => {
    if (typeof window === "undefined" || !window.matchMedia) return false;
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  });

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    const mql = window.matchMedia("(prefers-reduced-motion: reduce)");
    const onChange = (e: MediaQueryListEvent) => setReduced(e.matches);
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return reduced;
};

export default useReducedMotion;
